import * as React from 'react';
import { BrowserRouter } from "react-router-dom";
import { createTheme, CssBaseline } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import Routes from "./Routes";
import createStore from 'react-auth-kit/createStore';
import AuthProvider from 'react-auth-kit';

const themeLight = createTheme({
  palette: {
    background: {
      default: "#e4f0e2"
    }
  },
});

const themeDark = createTheme({
  palette: {
    primary: {
      main: '#142497',
      secondary:'#0E196A'
    },

    secondary: {
      main: '#00BCD4',
      secondary:'#00D4AA'
    },

    text: {
      primary: "#ffffff"
    },

    mode:"dark"
  },
  components: {
   
    MuiAlert: {
      defaultProps: {
        components: {
          CloseIcon: null,
          icon:null
        },
      },
    },

    MuiCssBaseline: {
      styleOverrides: {
        body: {
          //backgroundImage: 'radial-gradient(at 50% 50%, hsla(233, 100%, 16%, 0.5), hsl(220, 30%, 5%))',

          backgroundImage: 'radial-gradient(at 50% 50%, hsla(233, 100%, 16%, 1), hsl(233, 30%, 5%))',
        }
      }
    },
    
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            borderRadius:8,
            fontWeight:"bolder",
            color:"#fff"
          },
        },
        {
          props: { variant: 'secondary' },
          style: {
            borderRadius:8,
            fontWeight:"bolder",
            color:"#FFAB00",
          },
        },
        {
          props: { variant: 'contained-primary' },
          style: {
            backgroundColor: "#FFAB00",
            borderRadius:8
          },
        },
        
      ]
    },

    MuiCard: {
      variants: [
        {
          props: { variant: 'default' },
          style: {
            backgroundColor:"#252525"
          },
        },
        {
          props: { variant: 'paper' },
          style: {
            backgroundColor:"#fff",
            color:"white"
          },
        },
        
      ]
    },

    MuiListItemButton: {
      styleOverrides: {
        root: {
          color:"black",
          backgroundColor: "#fff",
          "&.Mui-selected": {
            backgroundColor: "#00BCD4!important"
          },
          "&:hover": {
              backgroundColor: "#FFF"
          }
        },
      },
    },

    MuiMobileStepper: {
      styleOverrides:{
        colorPrimary: {
          backgroundColor: "white",
        },
        dotActive:"white",
        progress: {
          backgroundColor: "green",
          "& *": {
            backgroundColor: "red",
          },
        },
      }
    }
  }
});

const store = createStore({
  authName:'_auth',
  authType:'cookie',
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === 'https:',
});

function App() {
  const [light, setLight] = React.useState(false);
  return (
    <ThemeProvider theme={light ? themeLight : themeDark}>
      <CssBaseline></CssBaseline>
        <AuthProvider  store={store}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
